/* @flow */

import glamorous from 'glamorous';

const TableListHead = glamorous.div({
  display: 'flex',
  flexGrow: 1,
  fontSize: '0.8rem',
});

export default TableListHead;
